module.exports = __webpack_public_path__ + "img/ht.2e72625b.png";